import './about.css'
import pfp from '../../images/EricaHeadshot.png';

function About() {
  return (
    <section id="about">
      <h1 className='section-header'>About Me</h1>
      <div className='about-content'>
        <div className='img-and-paragraph'>
            <div className="pfp"><img src={pfp} alt="Me!" style={{ width: '80px', height: '80px'}}></img></div>
            <div className='about-paragraph'>
              <p>
                Hi! My name is Erica Nwoga.
                I am a <span className="deco-about-text">Computer Science </span>
                graduate from the <span className="deco-about-text">University of Maryland</span>. 
              </p>
              <p>
                My background spans Banking and EdTech, giving me a unique perspective on building systems that are both highly secure and highly usable.
              </p>
              <p>
                At <span className="deco-about-text">M&T Bank</span>, I led the full-stack development of a high-volume loan-forgiveness application, where I personally redesigned the interface of a legacy application and presented the prototype to business stakeholders. The modernized application would significantly improve usability and data-handling efficiency.
              </p>
              <p>
                Additionally, my internship at <span className="deco-about-text">2U</span> deepened my commitment to user-centered development. LTI standards, centered around data privacy in learning platforms, informed how I built secure Python REST APIs.
              </p>
              <p>
                A little bit more about me. My hobbies include:<br /><br />
                🎨 Traditional and digital illustrating <br /><br />
                📚 Reading great stories <br /><br />
                💬 Learning new languages <br /><br />
                🎾 Playing tennis with friends<br /><br />
              </p>
              <p>Thank you for reading! My art portfolio will be posted soon...🌱</p>
            </div>
        </div>
      </div> 
    </section>
  )
}

export default About
